import { CustomTextField, InputPropsForAddAffiliates, emailRegexPattern, handleonKeyDownForEmailId } from '../../../helper';
import styles from '../../../features/ChangePassword/ResetPassword.module.css'

interface EmailProps {
    errors: any,
    register: any,
    disabled: boolean,
    moduleName: string
}
const EmailTextField = CustomTextField();
const EmailInputField = ({errors,register,disabled, moduleName}: EmailProps) => {
  return (
    <>
    <EmailTextField 
    variant={"outlined"}
    name={'email'}
    fullWidth
    {...register("email",{
      required: "Email is required!",
      pattern:{
          value: emailRegexPattern,
          message: "Enter valid email"
        }
    })}
    placeholder={"Enter Email"}
    InputProps={{
        style: InputPropsForAddAffiliates,
      }}
      onKeyDown={(e) => handleonKeyDownForEmailId(e, moduleName)}
      error={Boolean(errors?.email?.message)}
      disabled={disabled}
    />
    <span className={styles.errorMsgStyle}>{errors?.email?.message}</span>
    </>
  )
}

export default EmailInputField
